{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Plantilles",
    "DESCRIPTION": "Consulta les plantilles de missatges sincronitzades des de les teves safates d'entrada de WhatsApp. Per crear o editar una plantilla, gestiona-la amb el teu proveïdor.",
    "COUNT": "{n} plantilla | {n} plantilles",
    "LEARN_MORE": "Més informació sobre les plantilles de WhatsApp",
    "SYNC_TEMPLATES": "Sincronitza les plantilles",
    "SYNC_SUCCESS": "S'ha iniciat la sincronització de plantilles per a totes les safates d'entrada de WhatsApp. Les actualitzacions poden trigar uns minuts.",
    "PARTIAL_SYNC_ERROR": "S'ha iniciat la sincronització de plantilles per a algunes safates d'entrada de WhatsApp, però no s'ha pogut sincronitzar la resta.",
    "SYNC_ERROR": "No s'ha pogut iniciar la sincronització de plantilles. Torna-ho a provar.",
    "SEARCH_PLACEHOLDER": "Cerca per contingut o nom...",
    "MANAGE_IN_META": "Gestiona a Meta",
    "LOADING": "Carregant les plantilles de WhatsApp...",
    "EMPTY": "No s'han trobat plantilles de WhatsApp.",
    "NO_RESULTS": "Cap plantilla coincideix amb els filtres.",
    "FETCH_ERROR": "No s'han pogut carregar les plantilles de WhatsApp. Torna-ho a provar.",
    "PARTIAL_FETCH_ERROR": "No s'han pogut carregar algunes plantilles de WhatsApp. Torna-ho a provar.",
    "LAST_SYNC_ATTEMPT": "Últim intent de sincronització el {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "No enviada per aprovació a WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Totes les safates d'entrada",
      "ALL_LANGUAGES": "Tots els idiomes",
      "ALL_TYPES": "Tots els tipus"
    },
    "TYPES": {
      "TEXT": "Text",
      "IMAGE": "Imatge",
      "VIDEO": "Vídeo",
      "DOCUMENT": "Document",
      "CALL_TO_ACTION": "Crida a l'acció",
      "COPY_CODE": "Copia el codi"
    },
    "PREVIEW": {
      "TITLE": "Vista prèvia de la plantilla",
      "DESCRIPTION": "Previsualitza com apareix aquesta plantilla a WhatsApp.",
      "OPEN": "Previsualitza {name}",
      "CLOSE": "Tanca la vista prèvia",
      "DETAILS": "Detalls de la plantilla",
      "STATUS": "Estat",
      "TYPE": "Tipus de contingut",
      "CATEGORY": "Categoria",
      "LANGUAGE": "Idioma",
      "INBOXES": "Safates d'entrada"
    }
  }
}
